const channels = [
  {
    category: "Esportes",
    channels: [
      {
        name: "NBA",
        image: "https://totalsportek.army/assets2/images/categories/nba.webp",
        channels: [
          {
            name: "NBA 1",
            url: "https://gametimes.plus/nba/event1/",
          },
          {
            name: "NBA 2",
            url: "https://gametimes.plus/nba/event2/",
          },
          {
            name: "NBA 3",
            url: "https://gametimes.plus/nba/event3/",
          },
          {
            name: "NBA 4",
            url: "https://gametimes.plus/nba/event4/",
          },
          {
            name: "NBA 5",
            url: "https://gametimes.plus/nba/event5/",
          },
          {
            name: "NBA 6",
            url: "https://gametimes.plus/nba/event6/",
          },
          {
            name: "NBA 7",
            url: "https://gametimes.plus/nba/event7/",
          },
          {
            name: "NBA 8",
            url: "https://gametimes.plus/nba/event8/",
          },
          {
            name: "NBA 9",
            url: "https://gametimes.plus/nba/event9/",
          },
          {
            name: "NBA 10",
            url: "https://gametimes.plus/nba/event10/",
          },
          {
            name: "NBA 11",
            url: "https://gametimes.plus/nba/event11/",
          },
          {
            name: "NBA 12",
            url: "https://gametimes.plus/nba/event12/",
          },
          {
            name: "NBA 13",
            url: "https://gametimes.plus/nba/event13/",
          },
          {
            name: "NBA 14",
            url: "https://gametimes.plus/nba/event14/",
          },
        ],
      },
      {
        name: "SporTV",
        background: "#100940",
        image: "https://embedtvonline.com/images/sportv.png",
        channels: [
          {
            name: "SporTV 1",
            url: "https://nossoplayeronlinehd.site/tv/sportv",
          },
          {
            name: "SporTV 2",
            url: "https://nossoplayeronlinehd.site/tv/sportv2",
          },
          {
            name: "SporTV 3",
            url: "https://nossoplayeronlinehd.site/tv/sportv3",
          },
        ],
      },
      {
        name: "Prime Video",
        background: "#0bacef",
        image: "https://i.imgur.com/qAWg9xI.png",
        channels: [
          {
            name: "Prime video 1",
            url: "https://nossoplayeronlinehd.site/tv/primevideo",
          },
          {
            name: "Prime video 2",
            url: "https://nossoplayeronlinehd.site/tv/primevideo2",
          },
          {
            name: "Prime video 3",
            url: "https://nossoplayeronlinehd.site/tv/primevideo3",
          },
        ],
      },
      {
        name: "ESPN",
        image: "https://embedtvonline.com/images/espn.png",
        channels: [
          {
            name: "ESPN",
            url: "https://nossoplayeronlinehd.site/tv/espn",
          },
          {
            name: "ESPN 2",
            url: "https://nossoplayeronlinehd.site/tv/espn2",
          },
          {
            name: "ESPN 3",
            url: "https://nossoplayeronlinehd.site/tv/espn3",
          },
          {
            name: "ESPN 4",
            url: "https://nossoplayeronlinehd.site/tv/espn4",
          },
          {
            name: "ESPN 5",
            url: "https://nossoplayeronlinehd.site/tv/espn5",
          },
          {
            name: "ESPN 6",
            url: "https://nossoplayeronlinehd.site/tv/espn6",
          },
        ],
      },
      {
        name: "Premiere",
        image: "https://embedtvonline.com/images/premiere.png",
        channels: [
          {
            name: "Premiere Clubes",
            url: "https://nossoplayeronlinehd.site/tv/premiere",
          },
          {
            name: "Premiere 2",
            url: "https://nossoplayeronlinehd.site/tv/premiere2",
          },
          {
            name: "Premiere 3",
            url: "https://nossoplayeronlinehd.site/tv/premiere3",
          },
          {
            name: "Premiere 4",
            url: "https://nossoplayeronlinehd.site/tv/premiere4",
          },
          {
            name: "Premiere 5",
            url: "https://nossoplayeronlinehd.site/tv/premiere5",
          },
          {
            name: "Premiere 6",
            url: "https://nossoplayeronlinehd.site/tv/premiere6",
          },
          {
            name: "Premiere 7",
            url: "https://nossoplayeronlinehd.site/tv/premiere7",
          },
          {
            name: "Premiere 8",
            url: "https://nossoplayeronlinehd.site/tv/premiere8",
          },
        ],
      },
      {
        name: "Paramount",
        image: "https://embedtvonline.com/images/paramountplus.png",
        channels: [
          {
            name: "Paramount+",
            url: "https://nossoplayeronlinehd.site/tv/paramountplus",
          },
        ],
      },
      {
        name: "Cazé TV",
        image: "https://embedtvonline.com/images/cazetv.png",
        channels: [
          {
            name: "Cazé TV",
            url: "https://nossoplayeronlinehd.site/tv/caze1",
          },
          {
            name: "Cazé TV 2",
            url: "https://nossoplayeronlinehd.site/tv/caze2",
          },
          {
            name: "Cazé TV 3",
            url: "https://nossoplayeronlinehd.site/tv/caze3",
          },
        ],
      },
      {
        name: "Canal GOAT",
        background: "#fed218",
        image: "https://embedtvonline.com/images/canalgoat.png",
        channels: [
          {
            name: "Canal GOAT 1",
            url: "https://nossoplayeronlinehd.site/tv/caze1",
          },
          {
            name: "Canal GOAT 2",
            url: "https://nossoplayeronlinehd.site/tv/caze2",
          },
          {
            name: "Canal GOAT 3",
            url: "https://nossoplayeronlinehd.site/tv/caze3",
          },
        ],
      },
      {
        name: "UFC Fight Pass",
        image: "https://embedtvonline.com/images/ufcfightpass.png",
        channels: [
          {
            name: "UFC Fight Pass",
            url: "https://nossoplayeronlinehd.site/tv/ufcfightpass",
          },
        ],
      },
      {
        name: "Combate",
        image: "https://embedtvonline.com/images/combate.png",
        channels: [
          {
            name: "Combate",
            url: "https://nossoplayeronlinehd.site/tv/combate",
          },
        ],
      },
      {
        name: "Band Sports",
        image: "https://embedtvonline.com/images/bandsports.png",
        channels: [
          {
            name: "Band Sports",
            url: "https://nossoplayeronlinehd.site/tv/bandsports",
          },
        ],
      },
      {
        name: "Disney",
        background: "#082c3f",
        image: "https://embedtvonline.com/images/disneyplus.png",
        channels: [
          {
            name: "Disney+",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus1",
          },
          {
            name: "Disney+ 2",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus2",
          },
          {
            name: "Disney+ 3",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus3",
          },
          {
            name: "Disney+ 4",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus4",
          },
          {
            name: "Disney+ 5",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus5",
          },
          {
            name: "Disney+ 6",
            url: "https://nossoplayeronlinehd.site/tv/disneyplus6",
          },
        ],
      },
    ],
  },
  {
    category: "Entretenimento",
    channels: [
      {
        name: "BBB 26",
        image: "https://nossoplayeronlinehd.site/assets/images/bbb.jpeg",
        no_padding: true,
        channels: [
          {
            name: "Principal 1",
            url: "https://nossoplayeronlinehd.site/tv/bbb1",
          },
          {
            name: "Principal 2",
            url: "https://nossoplayeronlinehd.site/tv/bbb2",
          },
        ],
      },
      {
        name: "Telecine",
        background: "#a30000ff",
        image: "https://i.imgur.com/HRQZqQU.png",
        channels: [
          {
            name: "Telecine Premium",
            url: "https://nossoplayeronlinehd.site/tv/telecinepremium",
          },
          {
            name: "Telecine Pipoca",
            url: "https://nossoplayeronlinehd.site/tv/telecinepipoca",
          },
          {
            name: "Telecine Action",
            url: "https://nossoplayeronlinehd.site/tv/telecineaction",
          },
          {
            name: "Telecine Touch",
            url: "https://nossoplayeronlinehd.site/tv/telecinetouch",
          },
          {
            name: "Telecine Fun",
            url: "https://nossoplayeronlinehd.site/tv/telecinefun",
          },
          {
            name: "Telecine Cult",
            url: "https://nossoplayeronlinehd.site/tv/telecinecult",
          },
        ],
      },
      {
        name: "HBO",
        background: "#370e54",
        image: "https://i.imgur.com/BiJYc3J.png",
        channels: [
          {
            name: "HBO",
            url: "https://nossoplayeronlinehd.site/tv/hbo",
          },
          {
            name: "HBO 2",
            url: "https://nossoplayeronlinehd.site/tv/hbo2",
          },
          {
            name: "HBO+",
            url: "https://nossoplayeronlinehd.site/tv/hboplus",
          },
          {
            name: "HBO Familía",
            url: "https://nossoplayeronlinehd.site/tv/hbofamily",
          },
          {
            name: "HBO Extreme",
            url: "https://nossoplayeronlinehd.site/tv/hboxtreme",
          },
        ],
      },
      {
        name: "Discovery",
        background: "#00659bff",
        image: "https://i.imgur.com/zWOgYtB.png",
        channels: [
          {
            name: "Discovery Channel",
            url: "https://nossoplayeronlinehd.site/tv/discovery_channel_hd",
          },
          {
            name: "Discovery Turbo",
            url: "https://nossoplayeronlinehd.site/tv/discoveryturbo",
          },
          {
            name: "Discovery Kids",
            url: "https://nossoplayeronlinehd.site/tv/discoverykids",
          },
        ],
      },
      {
        name: "History",
        image: "https://embedtvonline.com/images/history.png",
        channels: [
          {
            name: "History",
            url: "https://nossoplayeronlinehd.site/tv/history",
          },
          {
            name: "History 2",
            url: "https://nossoplayeronlinehd.site/tv/history2",
          },
        ],
      },
    ],
  },
  {
    category: "TV Aberta",
    channels: [
      {
        name: "Globo",
        image: "https://embedtvonline.com/images/globo.webp",
        channels: [
          {
            name: "Globo SP",
            url: "https://nossoplayeronlinehd.site/tv/globosp",
          },
          {
            name: "Globo RJ",
            url: "https://nossoplayeronlinehd.site/tv/globorj",
          },
          {
            name: "Globo MG",
            url: "https://nossoplayeronlinehd.site/tv/globomg",
          },
          {
            name: "Globo RS",
            url: "https://nossoplayeronlinehd.site/tv/globoRS",
          },
        ],
      },
      {
        name: "SBT",
        image: "https://embedtvonline.com/images/sbtsp.png",
        channels: [
          {
            name: "SBT",
            url: "https://nossoplayeronlinehd.site/tv/sbt",
          },
        ],
      },
      {
        name: "Record TV",
        image: "https://embedtvonline.com/images/record.png",
        channels: [
          {
            name: "Record",
            url: "https://nossoplayeronlinehd.site/tv/record",
          },
        ],
      },
      {
        name: "Band",
        image: "https://i.imgur.com/G021JAn.png",
        background: "#098e4a",
        channels: [
          {
            name: "Band",
            url: "https://nossoplayeronlinehd.site/tv/band",
          },
        ],
      },
      {
        name: "Rede TV",
        no_padding: true,
        image: "https://i.imgur.com/BtfwYU7.png",
        channels: [
          {
            name: "Rede TV",
            url: "https://nossoplayeronlinehd.site/tv/redetv",
          },
        ],
      },
      {
        name: "TV Cultura",
        image: "https://i.imgur.com/MgzMlav.jpeg",
        background: "#2cbc5f",
        channels: [
          {
            name: "TV Cultura",
            url: "https://nossoplayeronlinehd.site/tv/cultura",
          },
        ],
      },
    ],
  },
];

export default channels;
